export { default } from './SignUpPersonalView'
